import axios from "axios";
import Swal from "sweetalert2";
import { getErrorMessage } from "../../utils/errorUtils";
import {
  CAMPAIGN_VIEW_REQUEST,
  CAMPAIGN_VIEW_FAIL,
  CAMPAIGN_VIEW_SUCCESS,
  CATEGORY_VIEW_REQUEST,
  CATEGORY_VIEW_FAIL,
  CATEGORY_VIEW_SUCCESS,
  TEAM_VIEW_REQUEST,
  TEAM_VIEW_FAIL,
  TEAM_VIEW_SUCCESS,
  PARTNER_VIEW_REQUEST,
  PARTNER_VIEW_FAIL,
  PARTNER_VIEW_SUCCESS,
  STORY_VIEW_SUCCESS,
  STORY_VIEW_REQUEST,
  STORY_VIEW_FAIL,
  CONTENT_VIEW_SUCCESS,
  CONTENT_VIEW_REQUEST,
  CONTENT_VIEW_FAIL,
  ADVISORY_VIEW_REQUEST,
  ADVISORY_VIEW_SUCCESS,
  ADVISORY_VIEW_FAIL,
  LANG_VIEW_REQUEST,
  LANG_VIEW_SUCCESS,
  LANG_VIEW_FAIL,
  CONTACT_VIEW_REQUEST,
  CONTACT_VIEW_FAIL,
  CONTACT_VIEW_SUCCESS,
  ADMIN_VIEW_REQUEST,
  ADMIN_VIEW_FAIL,
  ADMIN_VIEW_SUCCESS,
  TRANSACTION_VIEW_SUCCESS,
  TRANSACTION_VIEW_FAIL,
  TRANSACTION_VIEW_REQUEST,
  PARTNER_CONTACT_VIEW_REQUEST,
  PARTNER_CONTACT_VIEW_FAIL,
  PARTNER_CONTACT_VIEW_SUCCESS,
  FEATURE_VIEW_REQUEST,
  FEATURE_VIEW_FAIL,
  FEATURE_VIEW_SUCCESS,
  FAQ_VIEW_REQUEST,
  FAQ_VIEW_FAIL,
  FAQ_VIEW_SUCCESS,
} from "../constants/campaignConstants";

export const getCampaignView = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: CAMPAIGN_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "admin/get-campaigndetailsby-id",
      { campaign_id: id.campaignId, is_deleted: 0 },
      config
    );
    dispatch({ type: CAMPAIGN_VIEW_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load campaign");
    dispatch({
      type: CAMPAIGN_VIEW_FAIL,
      payload: errorMessage,
    });
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
  }
};

export const getCategoryDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: CATEGORY_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "admin/get-categoryby-id",
      { catId: id.categoryId },
      config
    );
    dispatch({ type: CATEGORY_VIEW_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load category");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: CATEGORY_VIEW_FAIL,
      payload: errorMessage,
    });
  }
};

export const getTeamDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: TEAM_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "admin/get-our-team-by-id",
      { id: id.teamId },
      config
    );
    dispatch({ type: TEAM_VIEW_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load team details");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: TEAM_VIEW_FAIL,
      payload: errorMessage,
    });
  }
};

export const getFeatureDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: FEATURE_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
        // "Content-Type": application / json,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "admin/feature/details",
      { id: id.featureId },
      config
    );
    dispatch({ type: FEATURE_VIEW_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load feature details");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: FEATURE_VIEW_FAIL,
      payload: errorMessage,
    });
  }
};

export const getPartnerDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: PARTNER_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "get-our-partner-by-id",
      { id: id.partnerId },
      config
    );
    dispatch({ type: PARTNER_VIEW_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load partner details");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: PARTNER_VIEW_FAIL,
      payload: errorMessage,
    });
  }
};

export const getStoryDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: STORY_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "get-success-story-byid",
      { id: id.storyId },
      config
    );
    dispatch({ type: STORY_VIEW_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load story details");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: STORY_VIEW_FAIL,
      payload: errorMessage,
    });
  }
};

export const getContentDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: CONTENT_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "get-page-by-id",
      { id: id.pageId },
      config
    );
    dispatch({ type: CONTENT_VIEW_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load content");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: CONTENT_VIEW_FAIL,
      payload: errorMessage,
    });
  }
};

export const getAdvisoryDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: ADVISORY_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "get-our-advisory-by-id",
      { id: id.advosoryId },
      config
    );
    dispatch({ type: ADVISORY_VIEW_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load advisory details");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: ADVISORY_VIEW_FAIL,
      payload: errorMessage,
    });
  }
};

export const getLanguageDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: LANG_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "languages-text-by-id",
      { id: id.langId },
      config
    );
    dispatch({ type: LANG_VIEW_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load language details");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: LANG_VIEW_FAIL,
      payload: errorMessage,
    });
  }
};

export const getContactDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: CONTACT_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "get-contact-us-by-id",
      { id: id.contactId },
      config
    );
    dispatch({ type: CONTACT_VIEW_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load contact details");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: CONTACT_VIEW_FAIL,
      payload: errorMessage,
    });
  }
};

export const getAdminDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "admin/get-user-profile-details",
      { user_id: id },
      config
    );
    dispatch({ type: ADMIN_VIEW_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load admin profile");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: ADMIN_VIEW_FAIL,
      payload: errorMessage,
    });
  }
};

export const getTransactionDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: TRANSACTION_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "get-trasactionetailsbyid",
      { id: id.transactionId },
      config
    );
    dispatch({ type: TRANSACTION_VIEW_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load transaction details");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: TRANSACTION_VIEW_FAIL,
      payload: errorMessage,
    });
  }
};

export const getContactPartnersDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: PARTNER_CONTACT_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    // http://localhost:8000/get-partner-details-byid
    const { data } = await axios.post(
      process.env.REACT_APP_API + "admin/get-partner-details-byid",
      { id: id.contactId },
      config
    );
    dispatch({ type: PARTNER_CONTACT_VIEW_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load partner contact");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: PARTNER_CONTACT_VIEW_FAIL,
      payload: errorMessage,
    });
  }
};

export const getFaqDetails = (token, id, type) => async (dispatch) => {
  try {
    dispatch({ type: FAQ_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "get-faq-que-by-id",
      {
        id:
          type === "accredited"
            ? id.accreditedFaqId
            : type === "investor"
            ? id.faqId
            : id.offerorId,
      },
      config
    );
    dispatch({ type: FAQ_VIEW_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = getErrorMessage(error, "Failed to load FAQ details");
    Swal.fire({
      title: errorMessage,
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: FAQ_VIEW_FAIL,
      payload: errorMessage,
    });
  }
};
